(() => {
  /**
   * Checks on an interval if jQuery is loaded.
   *
   * Reference source (https://stackoverflow.com/questions/7486309).
   *
   * @param {*} method - to run once the required libraries are loaded.
   * @param {Number} interval - lenght of time in ms to delay between required libaries check intervals.
   * @param {Number} timeout  - length of time in ms to stop libaries check after.
   * @param {Number} initialTime - Unix timestamp of initial check start.
   */
  function defer(method, interval = 50, timeout = 10000, initialTime = Date.now()) {
    if (window.jQuery) {
      method();
    } else if (Date.now() - initialTime > timeout) {
      console.warn("Script defer timed out after " + timeout + "ms before executing!");
    } else {
      setTimeout(function () {
        defer(method, interval, timeout, initialTime);
      }, interval);
    }
  }

  /**
   * Registers Need-It-Faster variant change event listeners.
   */
  function registerNeedItFaster() {
    if (window.jQuery && !!fasterVariantsMetadata && fasterProductVariantsCount > 1) {
      const needItFasterDiv = $(document).find(".itg-faster-checkout_");
      const needItFasterToolTip = $(document).find(".itg-tooltip-popup").children("p");
      const needItFasterCheckBox = $(document).find("#faster-checkbox");

      function hideNeedItFasterDiv() {
        needItFasterCheckBox.prop("checked", false);
        needItFasterDiv.css("visibility", "hidden");
        needItFasterDiv.addClass("hide-faster");
      }

      function updateExpeditedPrice(variant) {
        const variantPrice = variant.price * 0.01;
        let expedPercentage = fasterVariantsMetadata[variant.sku].percentage;
        let expedFixed = fasterVariantsMetadata[variant.sku].fixed;
        let fasterPrice = null;

        if (!expedFixed && !expedPercentage) {
          // Use default (product) metafields if not set for the variant:
          expedPercentage = fasterVariantsMetadata["default"].percentage;
          expedFixed = fasterVariantsMetadata["default"].fixed;
        }

        if (!!expedFixed) {
          // Set fixed price (overwrites percentage):
          fasterPrice = expedFixed;
          needItFasterCheckBox.data("type", "fixed");
        } else if (!!expedPercentage) {
          // Calculate and set percentage price:
          fasterPrice = Math.round(variantPrice * expedPercentage * 0.01);
          needItFasterCheckBox.data("type", "percentage");
        } // else leave price null

        if (!!fasterPrice) {
          fasterPriceFormatted = fasterPrice.toFixed(2);
          needItFasterCheckBox.val(fasterPriceFormatted);
          needItFasterDiv.find(".faster-price").text("(+$" + fasterPriceFormatted + ")");
          return true;
        }

        return false;
      }

      function updateExpeditedToolTip(variant) {
        if (!!variant && !!needItFasterToolTip) {
          // Defines the lead time for Need-It-Faster (in descending priority: variant, product, global-default):
          let fasterLead = fasterVariantsMetadata[variant.sku].lead || fasterVariantsMetadata["default"].lead || fasterLeadTimeDefault;
          if (!!fasterLead) {
            needItFasterToolTip.text(fasterToolTipDescription + " " + fasterLead + ".");
            return true;
          }
        }

        return false;
      }

      expeditedSelectCallback = function (variant) {
        if (!!variant && needItFasterCheckBox.length) {
          if (updateExpeditedPrice(variant) && updateExpeditedToolTip(variant)) {
            needItFasterDiv.css("visibility", "inherit"); //Un-hide Need-It-Faster if the price is defined.
            needItFasterDiv.removeClass("hide-faster");
          } else {
            hideNeedItFasterDiv(); //Hide Need-It-Faster if there is no defined price.
          }
        } else {
          hideNeedItFasterDiv(); //Hide Need-It-Faster if there is no defined variant or element.
        }
      };

      document.addEventListener("variant:changed", function (event) {
        expeditedSelectCallback(event.detail.variant);
      });
    } else {
      console.error("Need-It-Faster variant change listener failed to register due to missing or incorrect parameters!");
    }
  }

  // Wait until DOM is loaded
  document.addEventListener("DOMContentLoaded", () => {
    defer(registerNeedItFaster);
  });
})();
